import service from "./service";

async function getTemplates(payload) {
  try {
    const res = await service.getTemplates(payload);

    return res;
  } catch (error) {
    return null;
  }
}

async function templateDocuments() {
  try {
    const res = await service.templateDocuments();

    return res;
  } catch (error) {
    return null;
  }
}

export default {
  getTemplates,
  templateDocuments,
};
